import React from 'react';
import classNames from 'classnames';
import styles from './FormCheck.module.scss';

export interface IFormCheckProps extends Omit<React.HTMLProps<HTMLInputElement>, 'size'> {
  type?: 'radio' | 'checkbox' | 'switch';
  indeterminate?: boolean;
  label?: string;
  inline?: boolean
  size?: 'sm' | 'md'
  variant?: 'default' | 'card'
  description?: string
}

const FormCheck: React.FC<IFormCheckProps> = ({
  type = 'checkbox',
  label,
  indeterminate,
  size = 'md',
  inline,
  className,
  variant = 'default',
  description,
  ...props
}) => {
  const { id } = props;
  const inputRef = React.useRef<HTMLInputElement>(null);
  const inputType = type === 'switch' ? 'checkbox' : type;

  const handleCardClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (
      e.target instanceof HTMLInputElement
      || e.target instanceof HTMLLabelElement
    ) return;

    inputRef.current?.click();
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      className={classNames(className, styles.formCheck, styles[size], {
        [styles.inline]: inline,
        [styles.card]: variant === 'card',
        [styles.disabled]: props.disabled,
      })}
      onClick={variant === 'card' ? handleCardClick : undefined}
    >
      <input
        className={classNames(styles[`${type}Input`], {
          [styles.indeterminate]: indeterminate,
          [styles.switcher]: type === 'switch',
        })}
        ref={inputRef}
        type={inputType}
        {...props}
      />
      {!description && label && (<label htmlFor={id}>{label}</label>)}
      {description && (
        <div className="flex flex-column">
          <label htmlFor={id}>{label}</label>
          <p className="font-md-regular mb-0">{description}</p>
        </div>
      )}
    </div>
  );
};

export default FormCheck;
